var React = require('react');

function Medium (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Medium"),React.createElement("path",{"d":"M17.4922 8.99994C17.4922 13.8589 13.5856 17.8043 8.74608 17.8043C3.90658 17.8043 0 13.8589 0 8.99994C0 4.14101 3.90658 0.195557 8.74608 0.195557C13.5856 0.195557 17.4922 4.14101 17.4922 8.99994ZM27.074 8.99994C27.074 13.5673 25.111 17.2796 22.7009 17.2796C20.2909 17.2796 18.3279 13.5673 18.3279 8.99994C18.3279 4.43254 20.2909 0.720318 22.7009 0.720318C25.111 0.720318 27.074 4.41311 27.074 8.99994ZM31 8.99994C31 13.1009 30.3198 16.4244 29.4646 16.4244C28.6094 16.4244 27.9292 13.1009 27.9292 8.99994C27.9292 4.899 28.6094 1.57549 29.4646 1.57549C30.3198 1.57549 31 4.899 31 8.99994Z","key":1})]);
}

Medium.defaultProps = {"width":"31","height":"18","viewBox":"0 0 31 18","fill":"none"};

module.exports = Medium;

Medium.default = Medium;
